
// import React from "react";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faWindowRestore } from "@fortawesome/free-solid-svg-icons/faWindowRestore";
// import Col from "react-bootstrap/Col";
// import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableRow from "@material-ui/core/TableRow";
// import { bindActionCreators } from "redux";
// import { connect } from "react-redux";
// import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
// import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
// import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";

// import {
//   dateStringConvert,
//   dateStringTimeConvert,
//   titleCase,
// } from "../../Utils/titleCaseFunction";
// import { CustomPagination } from "../../Utils/Tables/CustomTable";
// import DashboardHeader from "../../Containers/Dasboard/DashboardHeader";
// import { CancelDialog } from "../../Utils/DeleteDialog";
// import {
//   EnhancedTableHead,
//   EnhancedTableToolbar,
//   MuiPaper,
// } from "../../Utils/Tables/CustomTable";
// import { useManagePurchase } from "./CustomHooks/useManagePurchase";
// import Grid from "@material-ui/core/Grid";
// import AddIcon from "@material-ui/icons/Add";
// import { makeStyles } from "@material-ui/core/styles";
// import Label from "../../Utils/FormInputs/Label";
// import TextField from "../../Utils/FormInputs/TextField";
// import { formatAmount } from "../../Utils/formatAmount";
// import { LoadingGif } from "../../Utils/Loader";
// import {
//   useExcelReports,
//   usePdfReports,
// } from "../Invoice/CustomHooks/useExcelReports";
// import Tooltip from "@material-ui/core/Tooltip";
// import CloseIcon from "@material-ui/icons/Close";
// import CustomDialog from "../../Utils/Dialog/CustomDialog";
// import { PurchaseDetailsPrint } from "./PurchaseDetailsPrint";
// import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
// import { history } from "../../Helpers/history";
// // Material-UI Icons for Pagination
// import Button from "@material-ui/core/Button";
// import Box from "@material-ui/core/Box";
// import Typography from "@material-ui/core/Typography";
// import { FirstPage, LastPage, NavigateBefore, NavigateNext } from "@material-ui/icons";

// const useStyles = makeStyles((theme) => ({
//   icon: {
//     width: "0.8em",
//     height: "0.8em",
//   },
// }));

// const ManagePurchase = ({ actions, snackbars }) => {
//   const {
//     purchases,
//     totalCount,
//     totalPages,          // New
//     activePage,
//     search,
//     from_date,
//     to_date,
//     handleChangeDate,
//     totalAmount,
//     openDialog,
//     handleOpenDialog,
//     handleCloseDialog,
//     handleCloseBar,
//     handleSearch,
//     handleChangePage,
//     handleChangeSearch,
//     isSuccess,
//     isError,
//     isLoading,
//     productPurchase,
//     loadingPurchase,
//     draftDialog,
//     handleCloseDraftDialog,
//     handleOpenDraftDialog,
//     handleCancelPurchase,
//     handleCancelDraft,
//   } = useManagePurchase(actions);

//   const currentObj = {
//     file_name: "Purchase List",
//     url: "Cpurchase/purchase_list_report",
//     params: { start_date: from_date, end_date: to_date },
//   };

//   const objPDF = {
//     file_name: "Purchase List PDF",
//     url: "Cpurchase/purchase_list_report_pdf",
//     params: { start_date: from_date, end_date: to_date },
//   };

//   const { exportExcel } = useExcelReports(actions, currentObj);
//   const { exportPDF } = usePdfReports(actions, objPDF);

//   const { open, message, variant } = snackbars;
//   const user = JSON.parse(sessionStorage.getItem("user"));
//   const singleUser = !user ? {} : user;
//   const permissions = !singleUser.permission ? {} : singleUser.permission;
//   const manage_purchase = !permissions.manage_purchase
//     ? {}
//     : permissions.manage_purchase;

//   const headData = [
//     { id: "date_created", numeric: false, disablePadding: false, label: "Date Created" },
//     { id: "invoiceNo", numeric: false, disablePadding: false, label: "Invoice No" },
//     { id: "manufName", numeric: false, disablePadding: false, label: "Supplier Name" },
//     { id: "purchaseDate", numeric: false, disablePadding: false, label: "Purchase Date" },
//     { id: "tAmount", numeric: false, disablePadding: false, label: "Total Amount" },
//     { id: "created_by", numeric: false, disablePadding: false, label: "Entrant Name" },
//     manage_purchase.create || manage_purchase.update || manage_purchase.delete
//       ? { id: "action", numeric: false, disablePadding: false, label: "Action" }
//       : { id: "nonaction", numeric: false, disablePadding: false, label: "" },
//   ];

//   const classes = useStyles();

//   const buttons = (
//     <>
//       <button className="btn pharmacy-info-btn btn-sm mr-3" onClick={handleOpenDraftDialog}>
//         Continue
//       </button>
//       <button className="btn pharmacy-grey-btn btn-sm" onClick={handleCloseDialog}>
//         No
//       </button>
//     </>
//   );
// // Modern & Professional Pagination Component
//   const ModernPagination = () => {
//     if (totalPages <= 1) return null;

//     const getVisiblePages = () => {
//       const pages = [];
//       const maxVisible = 5;
//       let start = Math.max(1, activePage - Math.floor(maxVisible / 2));
//       let end = Math.min(totalPages, start + maxVisible - 1);

//       if (end - start + 1 < maxVisible) {
//         start = Math.max(1, end - maxVisible + 1);
//       }

//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//       return pages;
//     };

//   const components = [
//     { label: "All Purchases", path: "/managepurchase" },
//     // { label: "Canceled Purchases", path: "/canceled-purchases" },
//     { label: "Drafted Purchases", path: "/drafted_purchase" },
//     { label: "Duplicate Invoices", path: "/duplicate_invoices" },
//   ];

//   return (
//     <div className="journals">
//       <DashboardHeader purchase managePurchase />
//       <PharmacySnackbar
//         open={open}
//         message={message}
//         variant={variant}
//         handleCloseBar={handleCloseBar}
//       />

//       <CustomDialog
//         maxWidth="md"
//         title="Cancel Purchase"
//         open={openDialog}
//         handleClose={handleCloseDialog}
//         buttons={buttons}
//         isOverflow={false}
//       >
//         <PurchaseDetailsPrint {...{ ...productPurchase, loading: loadingPurchase }} />
//       </CustomDialog>

//       <CancelDialog
//         openDialog={draftDialog}
//         handleClose={handleCloseDraftDialog}
//         heading="Use purchase as draft"
//         message="Would you like to use this purchase as a draft?"
//       >
//         <button className="btn pharmacy-info-btn btn-sm mr-3" onClick={handleCancelPurchase}>
//           Yes
//         </button>
//         <button className="btn pharmacy-grey-btn btn-sm" onClick={handleCancelDraft}>
//           No
//         </button>
//       </CancelDialog>

//       <ReusableRouteTabs value={history.location.pathname} tabHeading={components} />

//       <div className="general-ledger-header mb-3">
//         <Grid container spacing={0}>
//           <Grid item xs={6} md={8}>
//             <form onSubmit={handleSearch}>
//               <Form.Group as={Row} style={{ marginBottom: "-1%" }}>
//                 <Col sm={4}>
//                   <Form.Group as={Row}>
//                     <Label name="From" column sm={2} style={{ textAlign: "right" }} />
//                     <Col sm={10}>
//                       <TextField
//                         type="date"
//                         onChange={handleChangeDate}
//                         value={from_date}
//                         name="from_date"
//                       />
//                     </Col>
//                   </Form.Group>
//                 </Col>

//                 <Col sm={4}>
//                   <Form.Group as={Row}>
//                     <Label name="To" column sm={2} />
//                     <Col sm={10}>
//                       <TextField
//                         type="date"
//                         value={to_date}
//                         onChange={handleChangeDate}
//                         name="to_date"
//                       />
//                     </Col>
//                   </Form.Group>
//                 </Col>
//                 <Col sm={1}>
//                   <button type="submit" className="btn btn-sm pharmacy-btn-outline">
//                     Filter
//                   </button>
//                 </Col>
//               </Form.Group>
//             </form>
//           </Grid>

//           <Grid item xs={6} md={4}>
//             <div className="text-right">
//               <Link to="/addpurchase">
//                 <button className="btn btn-sm pharmacy-info-btn py-1">
//                   <AddIcon classes={{ root: classes.icon }} />
//                   Add New Purchase
//                 </button>
//               </Link>
//             </div>
//           </Grid>
//         </Grid>
//       </div>

//       <div className="mui-table">
//         <MuiPaper>
//           <EnhancedTableToolbar title="Purchases">
//             <span className="btn-group" style={{ flex: "1 1 100%" }}>
//               <button onClick={exportExcel} className="btn btn-sm mr-1 pharmacy-btn">
//                 Download Excel
//               </button>
//               <button onClick={exportPDF} className="btn btn-sm mr-1 pharmacy-btn">
//                 Download PDF
//               </button>
//             </span>
//             <Form.Control
//               type="text"
//               value={search ? titleCase(search) : ""}
//               onChange={handleChangeSearch}
//               className="form__control"
//               placeholder="Search by supplier name..."
//               style={{ float: "right" }}
//             />
//           </EnhancedTableToolbar>

//           <div className="sub-journal-bar" style={{ marginLeft: "0" }}>
//             <h6>
//               Total Purchase Amount : <strong>{formatAmount(totalAmount)}</strong>
//             </h6>
//           </div>

//           <Table aria-labelledby="tableTitle" size="medium">
//             <EnhancedTableHead headCells={headData} />
//             <TableBody>
//               {isLoading && (
//                 <TableRow>
//                   <TableCell colSpan={headData.length} align="center">
//                     <LoadingGif />
//                   </TableCell>
//                 </TableRow>
//               )}

//               {isSuccess && (
//                 purchases.length > 0 ? (
//                   purchases.map((d, index) => (
//                     <TableRow hover role="checkbox" tabIndex={-1} key={index} className="mui-table-row">
//                       <TableCell>{dateStringTimeConvert(d.date_added)}</TableCell>
//                       <TableCell>{d.chalan_no}</TableCell>
//                       <TableCell>{titleCase(d.supplier_name)}</TableCell>
//                       <TableCell>{dateStringConvert(d.purchase_date)}</TableCell>
//                       <TableCell>{formatAmount(d.total_amount)}</TableCell>
//                       <TableCell>{d.created_by}</TableCell>

//                       <TableCell id="mainbuttons">
//                         {manage_purchase.update || manage_purchase.delete ? (
//                           <>
//                             <Link to={`/manufacturerinvoice/${d.purchase_id}`}>
//                               <button className="btn pharmacy-btn btn-sm mr-3">
//                                 <FontAwesomeIcon icon={faWindowRestore} />
//                               </button>
//                             </Link>

//                             {manage_purchase.update && (
//                               <Link to={`/update_purchase/${d.purchase_id}`}>
//                                 <button className="btn pharmacy-warning-btn btn-sm mr-2">
//                                   <FontAwesomeIcon icon={faEdit} />
//                                 </button>
//                               </Link>
//                             )}

//                             <Tooltip title="Cancel Purchase">
//                               <button
//                                 onClick={() => handleOpenDialog(d.purchase_id)}
//                                 className="btn btn-sm pharmacy-gray-btn icon-button-holder"
//                               >
//                                 <CloseIcon className={classes.icon} />
//                               </button>
//                             </Tooltip>
//                           </>
//                         ) : null}
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={headData.length} align="center">
//                       No records found
//                     </TableCell>
//                   </TableRow>
//                 )
//               )}

//               {isError && (
//                 <TableRow>
//                   <TableCell colSpan={headData.length} align="center">
//                     The server did not return a valid response
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
// {/* Modern Professional Pagination */}
//           <ModernPagination />
//           {/* <CustomPagination
//             data={purchases}
//             records={50}
//             activePage={activePage}
//             total_count={totalCount}
//             total_pages={totalPages}          
//             handleChangeNextPage={handleChangePage}
//           /> */}
//         </MuiPaper>
//       </div>
//     </div>
//   );
// };

// function mapStateToProps(state) {
//   return { snackbars: state.snackbars };
// }

// function mapDispatchToProps(dispatch) {
//   return {
//     actions: {
//       snackbarActions: bindActionCreators(snackbarActions, dispatch),
//     },
//   };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(ManagePurchase)};

import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowRestore } from "@fortawesome/free-solid-svg-icons/faWindowRestore";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";

import {
  dateStringConvert,
  dateStringTimeConvert,
  titleCase,
} from "../../Utils/titleCaseFunction";
import DashboardHeader from "../../Containers/Dasboard/DashboardHeader";
import { CancelDialog } from "../../Utils/DeleteDialog";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPaper,
} from "../../Utils/Tables/CustomTable";
import { useManagePurchase } from "./CustomHooks/useManagePurchase";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import Label from "../../Utils/FormInputs/Label";
import TextField from "../../Utils/FormInputs/TextField";
import { formatAmount } from "../../Utils/formatAmount";
import { LoadingGif } from "../../Utils/Loader";
import {
  useExcelReports,
  usePdfReports,
} from "../Invoice/CustomHooks/useExcelReports";
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@material-ui/icons/Close";
import CustomDialog from "../../Utils/Dialog/CustomDialog";
import { PurchaseDetailsPrint } from "./PurchaseDetailsPrint";
import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
import { history } from "../../Helpers/history";

// Material-UI Icons for Pagination
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { FirstPage, LastPage, NavigateBefore, NavigateNext } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: "0.8em",
    height: "0.8em",
  },
  paginationContainer: {
    padding: theme.spacing(3),
    borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    backgroundColor: "#fafafa",
  },
  pageButton: {
    minWidth: 36,
    margin: "0 3px",
  },
}));

const ManagePurchase = ({ actions, snackbars }) => {
  const {
    purchases,
    totalCount,
    totalPages,
    activePage,
    search,
    from_date,
    to_date,
    handleChangeDate,
    totalAmount,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    handleCloseBar,
    handleSearch,
    handleChangePage,
    handleChangeSearch,
    isSuccess,
    isError,
    isLoading,
    productPurchase,
    loadingPurchase,
    draftDialog,
    handleCloseDraftDialog,
    handleOpenDraftDialog,
    handleCancelPurchase,
    handleCancelDraft,
  } = useManagePurchase(actions);

  const classes = useStyles();

  const { open, message, variant } = snackbars;
  const user = JSON.parse(sessionStorage.getItem("user")) || {};
  const permissions = user.permission || {};
  const manage_purchase = permissions.manage_purchase || {};
  const currentObj = {
    file_name: "Purchase List",
    url: "Cpurchase/purchase_list_report",
    params: { start_date: from_date, end_date: to_date },
  };

  const objPDF = {
    file_name: "Purchase List PDF",
    url: "Cpurchase/purchase_list_report_pdf",
    params: { start_date: from_date, end_date: to_date },
  };

  const { exportExcel } = useExcelReports(actions, currentObj);
  const { exportPDF } = usePdfReports(actions, objPDF);
  const headData = [
    { id: "date_created", numeric: false, disablePadding: false, label: "Date Created" },
    { id: "invoiceNo", numeric: false, disablePadding: false, label: "Invoice No" },
    { id: "manufName", numeric: false, disablePadding: false, label: "Supplier Name" },
    { id: "purchaseDate", numeric: false, disablePadding: false, label: "Purchase Date" },
    { id: "tAmount", numeric: false, disablePadding: false, label: "Total Amount" },
    { id: "created_by", numeric: false, disablePadding: false, label: "Entrant Name" },
    (manage_purchase.create || manage_purchase.update || manage_purchase.delete)
      ? { id: "action", numeric: false, disablePadding: false, label: "Action" }
      : null,
  ].filter(Boolean);

  // Modern Professional Pagination
  const ModernPagination = () => {
    if (totalPages <= 1) return null;

    const getVisiblePages = () => {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, activePage - Math.floor(maxVisible / 2));
      let end = Math.min(totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    };

    return (
      <Box className={classes.paginationContainer}>
        <Typography variant="body2" color="textSecondary">
          Page <strong>{activePage}</strong> of <strong>{totalPages}</strong> • {totalCount} records
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleChangePage(1)}
            disabled={activePage === 1}
          >
            <FirstPage fontSize="small" />
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={() => handleChangePage(activePage - 1)}
            disabled={activePage === 1}
          >
            <NavigateBefore fontSize="small" />
          </Button>

          {getVisiblePages().map((page) => (
            <Button
              key={page}
              variant={page === activePage ? "contained" : "outlined"}
              color={page === activePage ? "primary" : "default"}
              size="small"
              className={classes.pageButton}
              onClick={() => handleChangePage(page)}
            >
              {page}
            </Button>
          ))}

          <Button
            variant="outlined"
            size="small"
            onClick={() => handleChangePage(activePage + 1)}
            disabled={activePage === totalPages}
          >
            <NavigateNext fontSize="small" />
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={() => handleChangePage(totalPages)}
            disabled={activePage === totalPages}
          >
            <LastPage fontSize="small" />
          </Button>
        </Box>
      </Box>
    );
  };

  const components = [
    { label: "All Purchases", path: "/managepurchase" },
    { label: "Drafted Purchases", path: "/drafted_purchase" },
    { label: "Duplicate Invoices", path: "/duplicate_invoices" },
  ];

  return (
    <div className="journals">
      <DashboardHeader purchase managePurchase />

      <PharmacySnackbar
        open={open}
        message={message}
        variant={variant}
        handleCloseBar={handleCloseBar}
      />

      <CustomDialog
        maxWidth="md"
        title="Cancel Purchase"
        open={openDialog}
        handleClose={handleCloseDialog}
        buttons={
          <>
            <button className="btn pharmacy-info-btn btn-sm mr-3" onClick={handleOpenDraftDialog}>
              Continue
            </button>
            <button className="btn pharmacy-grey-btn btn-sm" onClick={handleCloseDialog}>
              No
            </button>
          </>
        }
        isOverflow={false}
      >
        <PurchaseDetailsPrint {...{ ...productPurchase, loading: loadingPurchase }} />
      </CustomDialog>

      <CancelDialog
        openDialog={draftDialog}
        handleClose={handleCloseDraftDialog}
        heading="Use purchase as draft"
        message="Would you like to use this purchase as a draft?"
      >
        <button className="btn pharmacy-info-btn btn-sm mr-3" onClick={handleCancelPurchase}>
          Yes
        </button>
        <button className="btn pharmacy-grey-btn btn-sm" onClick={handleCancelDraft}>
          No
        </button>
      </CancelDialog>

      <ReusableRouteTabs value={history.location.pathname} tabHeading={components} />

      <div className="general-ledger-header mb-3">
        <Grid container spacing={0}>
          <Grid item xs={6} md={8}>
            <form onSubmit={handleSearch}>
              <Form.Group as={Row} style={{ marginBottom: "-1%" }}>
                <Col sm={4}>
                  <Form.Group as={Row}>
                    <Label name="From" column sm={2} style={{ textAlign: "right" }} />
                    <Col sm={10}>
                      <TextField type="date" onChange={handleChangeDate} value={from_date} name="from_date" />
                    </Col>
                  </Form.Group>
                </Col>

                <Col sm={4}>
                  <Form.Group as={Row}>
                    <Label name="To" column sm={2} />
                    <Col sm={10}>
                      <TextField type="date" value={to_date} onChange={handleChangeDate} name="to_date" />
                    </Col>
                  </Form.Group>
                </Col>
                <Col sm={1}>
                  <button type="submit" className="btn btn-sm pharmacy-btn-outline">
                    Filter
                  </button>
                </Col>
              </Form.Group>
            </form>
          </Grid>

          <Grid item xs={6} md={4}>
            <div className="text-right">
              <Link to="/addpurchase">
                <button className="btn btn-sm pharmacy-info-btn py-1">
                  <AddIcon classes={{ root: classes.icon }} />
                  Add New Purchase
                </button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="mui-table">
        <MuiPaper>
          <EnhancedTableToolbar title="Purchases">
            <span className="btn-group" style={{ flex: "1 1 100%" }}>
              <button onClick={exportExcel} className="btn btn-sm mr-1 pharmacy-btn">Download Excel</button>
              <button onClick={exportPDF} className="btn btn-sm mr-1 pharmacy-btn">Download PDF</button>
            </span>
            <Form.Control
              type="text"
              value={search ? titleCase(search) : ""}
              onChange={handleChangeSearch}
              className="form__control"
              placeholder="Search by supplier name..."
              style={{ float: "right", width: "250px" }}
            />
          </EnhancedTableToolbar>

          <div className="sub-journal-bar" style={{ marginLeft: "0" }}>
            <h6>Total Purchase Amount : <strong>{formatAmount(totalAmount)}</strong></h6>
          </div>

          <Table aria-labelledby="tableTitle" size="medium">
            <EnhancedTableHead headCells={headData} />
            <TableBody>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    <LoadingGif />
                  </TableCell>
                </TableRow>
              )}

              {isSuccess && purchases.length > 0 ? (
                purchases.map((d, index) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index} className="mui-table-row">
                    <TableCell>{dateStringTimeConvert(d.date_added)}</TableCell>
                    <TableCell>{d.chalan_no}</TableCell>
                    <TableCell>{titleCase(d.supplier_name)}</TableCell>
                    <TableCell>{dateStringConvert(d.purchase_date)}</TableCell>
                    <TableCell>{formatAmount(d.total_amount)}</TableCell>
                    <TableCell>{d.created_by}</TableCell>

                    <TableCell id="mainbuttons">
                      {manage_purchase.update || manage_purchase.delete ? (
                        <>
                          <Link to={`/manufacturerinvoice/${d.purchase_id}`}>
                            <button className="btn pharmacy-btn btn-sm mr-3">
                              <FontAwesomeIcon icon={faWindowRestore} />
                            </button>
                          </Link>

                          {manage_purchase.update && (
                            <Link to={`/update_purchase/${d.purchase_id}`}>
                              <button className="btn pharmacy-warning-btn btn-sm mr-2">
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                            </Link>
                          )}

                          <Tooltip title="Cancel Purchase">
                            <button
                              onClick={() => handleOpenDialog(d.purchase_id)}
                              className="btn btn-sm pharmacy-gray-btn icon-button-holder"
                            >
                              <CloseIcon className={classes.icon} />
                            </button>
                          </Tooltip>
                        </>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {/* Modern Professional Pagination */}
          <ModernPagination />

        </MuiPaper>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagePurchase);